// extracted by mini-css-extract-plugin
module.exports = {"select":"SearchItem_select__2N9Y-"};